import axios from 'axios'
import { API_OCR, API_CLIENT_PROCESS, API_STRUCTURE } from '../../config/config.json'
import { decryptStorage } from 'utils/utils';
export async function getDocumentByType(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_OCR}/GetFile`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      "path": data.path
    }
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getDocumentList(data) {
  const responses = [];
  
  for (const item of data) {
    let token = decryptStorage(localStorage.getItem("token"));
    let config = {
      method: 'get',
      url: `${API_OCR}/GetFile`,
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        "path": item.filePath
      }
    };
    try {
      const response = await axios.request(config);
      responses.push(response?.data?.data);
    } catch (error) {
      responses.push({ data: { message: error.message }, status: 'error' });
    }
  }

  return responses;
}

export async function getConfigurationData(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/getsystemconfiguration`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data:data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function verificateData(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/ECD/ValidatorVerification`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data:data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function loadDocumentsValidate(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_OCR}/ValidateDocument`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data:data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      console.log("error",error)
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getSubject(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/Consult/getsubject`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data: data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getDataValidation(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_CLIENT_PROCESS}/Consult/getverificationinfo`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      externalRequestId: data.externalRequestId,
      reference: data.reference
    },
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getSetpsVerification(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_CLIENT_PROCESS}/Consult/getstepsresult`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      contractRequestId: data.crId,
    },
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}


export async function getStatusVerification() {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_CLIENT_PROCESS}/Consult/getstatus`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}
export async function getCertificateType() {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_CLIENT_PROCESS}/Consult/getcertificatetype`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getRejectedReason() {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_STRUCTURE}/cause-verification`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  };

  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getStatusValidation(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_OCR}/GetStatusValidation`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      'externalRequestId' : data.crId,
    },
  };

  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getInputs(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_STRUCTURE}/structure-validate`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data:data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getListAdditionalDocument(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_OCR}/AditionalDocumentList`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      'externalRequestId' : data.crId,
    },
  };

  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function registerAdditionalDocument(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_OCR}/AditionalDocumentRegister`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data:data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function updateAdditionalDocument(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_OCR}/AditionalDocumentUpdate`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    data:data
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}